// extracted by mini-css-extract-plugin
module.exports = {"submenuImg":"submenu-img_submenuImg__QjKrA","submenuImgLink":"submenu-img_submenuImgLink__QJgcO","submenuImgBG":"submenu-img_submenuImgBG__cJhK7"};